var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_292_1823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.001 12.3464C24.001 5.71902 18.6284 0.346436 12.001 0.346436C5.37356 0.346436 0.000976562 5.71902 0.000976562 12.3464C0.000976562 18.9739 5.37356 24.3464 12.001 24.3464C18.6284 24.3464 24.001 18.9739 24.001 12.3464Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8699 7.41646C18.5124 7.58941 19.019 8.09602 19.192 8.73852C19.5133 9.91232 19.5009 12.3588 19.5009 12.3588C19.5009 12.3588 19.5009 14.7929 19.192 15.9667C19.019 16.6092 18.5124 17.1158 17.8699 17.2887C16.6961 17.5976 12.0009 17.5976 12.0009 17.5976C12.0009 17.5976 7.31808 17.5976 6.13193 17.2764C5.48943 17.1034 4.98285 16.5968 4.80987 15.9543C4.50098 14.7929 4.50098 12.3464 4.50098 12.3464C4.50098 12.3464 4.50098 9.91232 4.80987 8.73852C4.98285 8.09602 5.50178 7.57707 6.13193 7.40407C7.30573 7.09522 12.0009 7.09521 12.0009 7.09521C12.0009 7.09521 16.6961 7.09521 17.8699 7.41646ZM14.4103 12.3464L10.5059 14.5952V10.0977L14.4103 12.3464Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_292_1823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.000976562 0.346436)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.101b9be5d0d77a2e2cc6b867326ba197.svg";
export { ForwardRef as ReactComponent };